import React from "react";
import LandingBanner from "../assets/LandingBanner.jpg";
const HomeBanner = () => {
  return (
       <section className="relative h-[calc(100vh-72px)] w-screen overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={LandingBanner}
          alt="Qualityzone"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-[color:var(--navy)]/70" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/70" />
      </div>

      <div className="relative z-10 flex h-full items-center">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white backdrop-blur">
              <span className="h-2 w-2 rounded-full bg-[color:var(--brand-accent)]" />
              Minority-Owned Business
            </div>

            <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
              Connecting Quality Experts Globally
            </h1>

            <p className="mt-5 text-base sm:text-lg text-white/85 max-w-2xl">
              Training and consulting services that strengthen compliance,
              improve operational performance, and build resilient quality
              systems.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#services"
                className="inline-flex items-center justify-center rounded-lg px-6 py-3 text-sm font-semibold bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:opacity-95 transition"
              >
                Explore Services
              </a>
              <a
                href="#about"
                className="inline-flex items-center justify-center rounded-lg px-6 py-3 text-sm font-semibold bg-white/15 text-white hover:bg-white/25 transition"
              >
                Learn About Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default HomeBanner;